import {
  type ProjectAgentAssistantPayload,
  type ProjectFeedEvent,
} from "../../../services/askPunttProjectFeed.types";

/** Stable id for testids / keys on agent turn cards. */
export function feedTurnMessageId(event: ProjectFeedEvent): string {
  if (event.chatMessageId) return event.chatMessageId;
  if (event._id.startsWith("proj-")) return event._id.slice("proj-".length);
  return event._id;
}

export function assistantTurnPayload(
  event: ProjectFeedEvent,
): ProjectAgentAssistantPayload {
  return (event.payload ?? {}) as ProjectAgentAssistantPayload;
}

export function isAssistantTurnPending(event: ProjectFeedEvent): boolean {
  if (event.type !== "agent_assistant_turn") return false;
  const status = assistantTurnPayload(event).status ?? "completed";
  return status === "pending" || status === "streaming";
}

/** True when the unified timeline still has an in-flight Puntt reply. */
export function timelineHasPendingAssistant(
  events: ProjectFeedEvent[],
): boolean {
  return events.some(isAssistantTurnPending);
}
